module.exports = __webpack_public_path__ + "media/images/excellent_smiley-530338ea4d7708d858d707dc6fae7dfa.svg";